// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextInput-module__input--fg2J5 {
    border: none;
}

.TextInput-module__input--fg2J5:focus {
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/TextInput/TextInput.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;AAChB;;AAEA;IACI,aAAa;AACjB","sourcesContent":[".input {\n    border: none;\n}\n\n.input:focus {\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input": `TextInput-module__input--fg2J5`
};
export default ___CSS_LOADER_EXPORT___;
